// Imports
import { isDevelopment } from 'src/lib/utils.js';

//polyfill

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                Element.prototype.webkitMatchesSelector;
  }
  
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
  
      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }



(function () {
    'use strict';

    // Global variables
    var jcu_js_v1 = {
        'fn': {},
        'vars': {}
    };


    jcu_js_v1.fn.removeH1 = function ($component_id) {
        var component = document.querySelector($component_id);
        if (component !== null) {
            var h1 = component.querySelector("h1");
            if (h1 !== null) {
                h1.parentNode.removeChild(h1);
            }
        }
    }

    jcu_js_v1.fn.ajaxRequest = function(method, url, data, callback){
        let request = new XMLHttpRequest();

        request.open(method,url,true);
    
        if(method == "POST"){
            request.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
        }
          request.onreadystatechange = function() {
            if (request.readyState == 4) {
                if (request.status == 200) {
                    let response = request.responseText;
                    callback(response);
                }
            }
        } 
        request.send(data);
    }

    jcu_js_v1.fn.debounce = function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    jcu_js_v1.vars.cookie_name = "jcu_saved_courses";

    // creates the cookie for saved courses
    jcu_js_v1.fn.bake_cookie = function (name, value) {
        var date, expires;
        date = new Date();
        //set it to 45 days
        date.setTime(date.getTime() + (45 * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
        var cookie = [name, '=', JSON.stringify(value), expires, '; domain=.', window.location.host.toString(), '; path=/;'].join('');
        document.cookie = cookie;
        // console.log(document.cookie);
    }

    // create a localhost cookie
    jcu_js_v1.fn.bake_local_cookie = function (cookie_name, cookie_value) {
        var right_now = new Date();
        var days_active = 45;
        right_now.setTime(right_now.getTime() + (days_active * 24 * 60 * 60 * 1000));
    
        var expiry_time = 'expires=' + right_now.toUTCString();
        var cookie_entry = cookie_name + '=' + JSON.stringify(cookie_value) + ';';
    
        document.cookie = cookie_entry + expiry_time + '; path=/;';
    };

    // returns the cookie for saved courses
    jcu_js_v1.fn.read_cookie = function (name) {
        var result = document.cookie.match(new RegExp(name + '=([^;]+)'));
        result && (result = JSON.parse(result[1]));
        return result;
    }

    // adds/removes course via asset id to the cookie
    jcu_js_v1.fn.checkSavedCoursesCookie = function ($assetid) {
        var cookie = jcu_js_v1.fn.read_cookie(jcu_js_v1.vars.cookie_name);
        //if the cookie doesnt exist, create it.

        if (cookie === null) {
            var arr = [];
            arr.push($assetid);
            jcu_js_v1.fn.bake_cookie(jcu_js_v1.vars.cookie_name, arr);

        } else {
            //if id isnt in the array add it else remove it
            if (cookie.indexOf($assetid) === -1) {
                cookie.push($assetid);
            } else {
                var idx = cookie.indexOf($assetid);
                cookie.splice(idx, 1);
            }
            jcu_js_v1.fn.bake_cookie(jcu_js_v1.vars.cookie_name, cookie);
        }
        jcu_js_v1.fn.updateCourseSaveButton();
        jcu_js_v1.fn.updateSavedCoursesCount();
    }

    //removes course from cookie
    jcu_js_v1.fn.removeCourseFromSavedCoursesCookie = function ($assetid) {
        var cookie = jcu_js_v1.fn.read_cookie(jcu_js_v1.vars.cookie_name);
        if (cookie !== null) {
            //if id isnt in the array add it else remove it
            if (cookie.indexOf($assetid) !== -1) {
                var idx = cookie.indexOf($assetid);
                cookie.splice(idx, 1);
            }
            jcu_js_v1.fn.bake_cookie(jcu_js_v1.vars.cookie_name, cookie);
        }

        jcu_js_v1.fn.updateCourseSaveButton();
        jcu_js_v1.fn.updateSavedCoursesCount();
    }

    //initialises the clicks on the stars to save the course on course details page
    jcu_js_v1.fn.initCourseSavingClick = function () {
        var courseDetailSaveButton = document.querySelector('.course-banner__save');
        if (courseDetailSaveButton !== null) {
            var assetid = courseDetailSaveButton.dataset.assetid;
            courseDetailSaveButton.addEventListener('click', function (event) {
                event.preventDefault();
                // console.log('here');
                //jcu_js_v1.fn.updateCourseStorage(assetid);
                jcu_js_v1.fn.checkSavedCoursesCookie(assetid);
            });

            jcu_js_v1.fn.updateCourseSaveButton();
            jcu_js_v1.fn.updateSavedCoursesCount();
        }
    }

    // saving of courses on the details page of the course
    jcu_js_v1.fn.updateCourseSaveButton = function () {
        //var savedCourses = jcu_js_v1.fn.getLocalStorage('savedCourses');
        var savedCourses = jcu_js_v1.fn.read_cookie(jcu_js_v1.vars.cookie_name);
        //if(cookie !== null){

        // console.log(savedCourses);

        var button = document.querySelector('.course-banner__save');
        if (button !== null && savedCourses !== null) {
            //var coursesArr = JSON.parse(savedCourses);
            var assetid = button.dataset.assetid;
            if (savedCourses.indexOf(assetid) !== -1) {
                button.classList.add("saved");
            } else {
                button.classList.remove("saved");
            }
        }
        // }
    }

    // update course count bubble in utility bar
    jcu_js_v1.fn.updateSavedCoursesCount = function () {
        //var savedCourses = jcu_js_v1.fn.getLocalStorage('savedCourses');
        var savedCourses = jcu_js_v1.fn.read_cookie(jcu_js_v1.vars.cookie_name);
        var courseCount = 0;

        if (savedCourses !== null) {
            //var coursesArr = JSON.parse(savedCourses);
            courseCount = savedCourses.length;
        }

        // add the active class to hth button so we can fill the icon
        var saveCoursesButton = document.querySelector('.jcu-v1__utils__save');

        // console.log(saveCoursesButton);
        
        // if the saved courses button is found
        if(saveCoursesButton !== null){
            var countBubble = document.querySelector('.jcu-v1__utils__saved-count');

            // Update or remove existing count
            if (countBubble !== null) {

                if (courseCount > 0) {

                    countBubble.innerHTML = String(courseCount);
                    saveCoursesButton.classList.add('active');

                } else {

                    countBubble.parentNode.removeChild(countBubble);
                    saveCoursesButton.classList.remove('active');
                }

                // Add new count if it's greater than 0
            } else if (courseCount > 0) {

                var newBubble = document.createElement('span');
                newBubble.className = 'jcu-v1__utils__saved-count';
                newBubble.innerHTML = String(courseCount);
                var savedIcon = document.querySelector('.jcu-v1__utils__save .jcu-v1__utils__icon').appendChild(newBubble);
                saveCoursesButton.classList.add('active');
            }
        }
    }

    // Check for a JCU document referrer and return the result
    jcu_js_v1.fn.hasValidReferrer = function() {
        var document_referrer = document['referrer'];
        var check_domain = 'jcu.edu.au';

        // Development referrer
        if(isDevelopment()) {
            check_domain = 'http://0.0.0.0:8080/';
        }

        // console.log('The referrer is ' + document_referrer);

        // Return result validation
        if(document_referrer.indexOf(check_domain) !== -1) {
            return true;
        } else {
            return false;
        }
    };

    // Compare country code against domestic codes
    jcu_js_v1.fn.countryIsInternational = function(country_code) {
        var domestic_codes = ['AU', 'NZ'];

        if(domestic_codes.indexOf(country_code) === -1) {
            return true;
        } else {
            return false;
        }
    }

    // Check for geolocation include
    jcu_js_v1.fn.checkForLocation = function(event) {
        var geolocation_element = document.querySelector('#jcu-geolocated');

        if(geolocation_element !== null) {
            var automatic_location = geolocation_element.getAttribute('data-auto-location');

            // Check cookies
            var geolocation_cookie_data = jcu_js_v1.fn.getGeolocationCookieData();
            var cookie_name = geolocation_cookie_data['name'];
            var geolocation_cookie = geolocation_cookie_data['cookie'];

            if(geolocation_cookie === null) {
                // No cookie set
                // Set preferences
                var data_preference = 'DOM';

                // Set international preference
                if(jcu_js_v1.fn.countryIsInternational(automatic_location)) {
                    data_preference = 'INTL';
                }
                
                // Set up location data
                geolocation_cookie = {
                    'automatic_location': automatic_location,
                    'preference': data_preference
                };
            } else {
                // Cookie present
                // Override the automatic location
                geolocation_cookie['automatic_location'] = automatic_location;
            }

            // Set the cookie data
            if(isDevelopment()) {
                jcu_js_v1.fn.bake_local_cookie(cookie_name, geolocation_cookie);
            } else {
                jcu_js_v1.fn.bake_cookie(cookie_name, geolocation_cookie);
            }
        }
    };

    // Get geolocation cookie data
    jcu_js_v1.fn.getGeolocationCookieData = function() {
        var cookie_name = 'jcu_geodata';
        var geolocation_cookie = jcu_js_v1.fn.read_cookie(cookie_name);

        return {
            'name': cookie_name,
            'cookie': geolocation_cookie
        }
    };

    // Check for international visitor
    jcu_js_v1.fn.checkForInternationalVisitor = function() {
        // Check cookies
        var geolocation_cookie_data = jcu_js_v1.fn.getGeolocationCookieData();
        var geolocation_cookie = geolocation_cookie_data['cookie'];

        if(geolocation_cookie !== null) {
            var user_country_code = geolocation_cookie['automatic_location'];

            // Returns true when User is International
            return jcu_js_v1.fn.countryIsInternational(user_country_code);
        }

        // Assume Domestic if no cookie exists
        return false;
    };

    // Check for international page
    jcu_js_v1.fn.checkForInternationalPage = function() {
        var international_parameter = 'international';
        var browser_query = window['location']['search'];

        if(browser_query.indexOf(international_parameter) !== -1) {
            // Page is International variant
            return true;
        } else {
            // Check for server override
            var page_type_element = document.querySelector('.jcu-v1__page-type');

            if(page_type_element !== null) {
                var is_international = page_type_element.getAttribute('data-international');

                if(is_international === 'true') {
                    // Page is International variant
                    return true;
                }
            }
        }

        // Page is Domestic variant
        return false;
    };

    // Convert page to international content
    jcu_js_v1.fn.convertPageToInternational = function() {
        // Construct a new URL
        var international_url = window['location']['href'];

        // Check for queries
        var browser_query = window['location']['search'];

        if(browser_query !== '') {
            international_url += '&international';
        } else {
            international_url += '?international';
        }

        // Redirect to International page
        window['location'].replace(international_url);
    }

    // Check if the course content needs to refresh based on audience
    jcu_js_v1.fn.checkContentAudience = function() {
        var is_international_visitor = jcu_js_v1.fn.checkForInternationalVisitor();
        var is_international_page = jcu_js_v1.fn.checkForInternationalPage();
        var update_page = false;

        // Only perform updates for international visitors on domestic pages
        if(is_international_visitor && !is_international_page) {
            var is_valid_referrer = jcu_js_v1.fn.hasValidReferrer();

            if(!is_valid_referrer) {
                // User is International and is visiting the Courses page without going through JCU
                update_page = true;
            } else {
                var document_referrer = document['referrer'];

                if(document_referrer.indexOf('search') !== -1) {
                    // User is International and is visiting the Courses page from JCU Search
                    update_page = true;
                }
            }
        }

        if(update_page) {
            // Update the page content
            jcu_js_v1.fn.convertPageToInternational();
        }
    }

    // Init functions
    jcu_js_v1.fn.initCourseSavingClick();

    // Check for geolocation detection - Disabled due to Geolocation inaccuracy 
    // jcu_js_v1.fn.checkForLocation(); 
    // GeoLoc Element disabled in Customisation 1256140

    if(document.querySelector('.course-breadcrumb') !== null) {
        // Check audience
        jcu_js_v1.fn.checkContentAudience();
    }

    // Make squiz variable available to the console for debugging
    window.jcu_js_v1 = jcu_js_v1;
}());
